import { render, staticRenderFns } from "./PackagingMaterialFields.vue?vue&type=template&id=6c42f1f0"
import script from "./PackagingMaterialFields.vue?vue&type=script&lang=js"
export * from "./PackagingMaterialFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports